import { inject, Signal } from '@angular/core';
import { LocalizationService } from '../localization.service';
import { FormatOptions } from '../types/format-options';

export type Formatter = (value: string | number | object | undefined | null | Date,
                         format: string,
                         options?: FormatOptions) => Signal<string>

export function formatter(): Formatter {
  const service = inject(LocalizationService);
  return (value: string | number | object | undefined | null | Date,
          format: string | undefined,
          options?: FormatOptions) => service.format(value, format, options)
}
